export const CPD_STATUSES = {
  granted: "granted",
  applied_for: "applied_for",
  not_applicable: "not_applicable",
};

export const REF_TYPES = {
  ICGP: 0,
  RCPI: 1,
  FSEM: 2,
  IPNA: 3,
  CERTIFICATE_OF_PARTICIPATION: 4,
  NMBI: 5,
};

export const ZOOM_INFO_STATUS = {
  open: "open",
  closed: "closed",
  hideInProgress: "hideInProgress",
};

export const MODAL_DELETE_CONFIRMATION_TYPE = {
  webinar: "webinar",
  groupWebinar: "groupWebinar",
  user: "user",
  sponsor: "sponsor",
  partner: "partnership",
  discipline: "discipline",
  booking: "booking",
  superhost: "superhost",
  studygroups: "studygroups",
  courseMaterials: "courseMaterials",
  groupMember: "groupMember",
  groupInvite: "groupInvite",
  clientUrls: "clientUrls",
};

export const SKIP_QUIZ_STATUS = {
  unavaliable: "unavaliable",
  available: "avaliable",
};

export const STATS_HEADER = [
  {
    title: "Beginning Date & Time",
    className: "stats_item_header_title",
  },
  {
    title: "Webinar Title",
    className: "stats_item_text",
  },
  {
    title: "Recording",
    className: "stats_item_text",
  },
  {
    title: "Registered Attendees",
    className: "stats_item_text",
  },
  {
    title: "Webinar Attendees",
    className: "stats_item_text",
  },
  {
    title: "On-Demand Viewers",
    className: "stats_item_text",
  },
  {
    title: "In-Person Attendees",
    className: "stats_item_text",
  },
  // {
  //   title: 'Data Visualisation',
  //   className: 'stats_item_text',
  // },
];



// WEBPACK FOOTER //
// ./src/constants/mixed.js